export default "__VITE_ASSET__K2RBP4hl__"